
import React from 'react';
import { useDownload } from './download/useDownload';
import LoadingState from './download/LoadingState';
import ErrorState from './download/ErrorState';
import DownloadActions from './download/DownloadActions';
import DownloadFooter from './download/DownloadFooter';
import { extractSpotifyTrackId } from '@/lib/spotify';

interface DownloadPageProps {
  trackId?: string;
}

const DownloadPage: React.FC<DownloadPageProps> = ({ trackId }) => {
  const {
    isLiked,
    isPlaying,
    countdownActive,
    timeLeft,
    downloadReady,
    isDownloading,
    isLoading,
    error,
    downloadInfo,
    track,
    handlePlayPreview,
    handleLikeTrack,
    handleDownload
  } = useDownload(trackId || "");

  if (isLoading) {
    return <LoadingState />;
  }
  
  if (error || !track || !downloadInfo) {
    return <ErrorState errorMessage={error} />;
  }

  // Extract Spotify track ID for embedding
  const spotifyEmbedId = track.id || extractSpotifyTrackId(downloadInfo.spotifyUrl);

  return (
    <div className="max-w-xl mx-auto animate-fade-in">
      <div className="glass-card rounded-lg overflow-hidden shadow-sm">
        <div className="p-6 space-y-6">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-medium">❤️ Like Track → Get Gift 🎁</h2>
          </div>

          {/* Spotify Embed - Portrait Layout */}
          {spotifyEmbedId && (
            <div className="w-full overflow-hidden rounded-md">
              <iframe 
                src={`https://open.spotify.com/embed/track/${spotifyEmbedId}`}
                width="100%" 
                height="352" 
                frameBorder="0" 
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                loading="lazy"
                className="w-full rounded-md"
                style={{ maxWidth: "100%" }}
              />
            </div>
          )}

          <div className="space-y-4">
            <DownloadActions 
              isLiked={isLiked}
              countdownActive={countdownActive}
              timeLeft={timeLeft}
              downloadReady={downloadReady}
              isDownloading={isDownloading}
              onLikeTrack={handleLikeTrack}
              onDownload={handleDownload}
            />
          </div>

          <DownloadFooter description={downloadInfo?.description} />
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
